import React from "react";
import { RADAR } from "@/content/site";
import { track } from "@/lib/track";

const fmtDate = (iso) => {
    if (!iso) return "";
    const [y, m, d] = iso.split("-").map(Number);
    return new Date(y, m - 1, d).toLocaleDateString("pt-BR", { day: "2-digit", month: "short", year: "numeric" });
};

const Part = ({ label, children, light }) => (
    <div>
        <p className={`font-sans text-[9.5px] uppercase tracking-[0.26em] mb-1.5 ${light ? "text-[#8a6a22]" : "text-[#7E8978]"}`}>{label}</p>
        <p className={`font-sans font-light text-[13.5px] leading-[1.75] max-w-2xl ${light ? "text-[#2d3a31]" : "text-[#B0B6A6]"}`}>{children}</p>
    </div>
);

const RadarItem = ({ item, full = false }) => {
    const S = RADAR.secoes;
    return (
        <article data-testid={`radar-item-${item.id}`} className="flex flex-col gap-4 py-8 border-t border-[#1B3025]">
            <div className="flex flex-wrap items-center gap-3 font-sans text-[10px] uppercase tracking-[0.24em]">
                <span className="text-[#C7A659]">{RADAR.categorias[item.category] || item.category}</span>
                <span className="text-[#7E8978]">{fmtDate(item.published_on)}</span>
            </div>
            <h3 className="font-serif font-light text-[20px] md:text-[23px] leading-snug text-[#F2EFE5]">{item.title}</h3>
            {item.what && <Part label={S.what}>{item.what}</Part>}
            {full && item.evidence && <Part label={S.evidence}>{item.evidence}</Part>}
            {full && item.why && <Part label={S.why}>{item.why}</Part>}
            {item.question && (
                <div>
                    <p className="font-sans text-[9.5px] uppercase tracking-[0.26em] mb-1.5 text-[#C7A659]">{S.question}</p>
                    <p className="font-serif italic text-[17px] md:text-[18px] leading-[1.5] text-[#F2EFE5] max-w-2xl">{item.question}</p>
                </div>
            )}
            {full && item.relation && <Part label={S.relation}>{item.relation}</Part>}
            <p className="font-sans font-light text-[11.5px] text-[#7E8978]">
                Fonte:{" "}
                <a
                    href={item.source_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`radar-source-${item.id}`}
                    onClick={() => track("radar_source_click", { id: item.id })}
                    className="border-b border-[#C7A659]/40 hover:text-[#C7A659] transition-colors"
                >
                    {item.source} ↗
                </a>
            </p>
        </article>
    );
};

export default RadarItem;
